// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph___2eXNE"};